import { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useConvites } from '../hooks/useConvites';
import { cores } from '../styles/cores';
import { Avatar } from './UI';

export function Layout() {
  const { usuario, sair } = useAuth();
  const navegar = useNavigate();
  const { pendentes } = useConvites(usuario?.uid, usuario?.email);

  const [ehMobile, setEhMobile] = useState(window.innerWidth < 768);
  const [menuAberto, setMenuAberto] = useState(false);

  useEffect(() => {
    const aoRedimensionar = () => setEhMobile(window.innerWidth < 768);
    window.addEventListener('resize', aoRedimensionar);
    return () => window.removeEventListener('resize', aoRedimensionar);
  }, []);

  const aoSair = async () => {
    await sair();
    navegar('/login');
  };

  const itensMenu = [
    { rota: '/', rotulo: 'Dashboard', icone: '▦', fim: true },
    { rota: '/projetos', rotulo: 'Projetos', icone: '📁' },
    { rota: '/convites', rotulo: 'Convites', icone: '✉️', badge: pendentes.length },
    { rota: '/equipe', rotulo: 'Equipe', icone: '👥' },
    { rota: '/historico', rotulo: 'Histórico', icone: '🕓' },
  ];

  const sidebarVisivel = !ehMobile || menuAberto;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: cores.fundo }}>
      {ehMobile && (
        <header
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: 56,
            backgroundColor: '#fff',
            borderBottom: `1px solid ${cores.card}`,
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            gap: 12,
            zIndex: 200,
          }}
        >
          <button
            onClick={() => setMenuAberto((a) => !a)}
            style={{
              border: 'none',
              background: 'transparent',
              fontSize: 22,
              cursor: 'pointer',
              color: cores.texto,
            }}
          >
            ☰
          </button>
          <strong style={{ color: cores.texto }}>Sint Projetos</strong>
        </header>
      )}

      {sidebarVisivel && (
        <aside
          style={{
            width: 220,
            backgroundColor: '#fff',
            borderRight: `1px solid ${cores.card}`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: ehMobile ? 'fixed' : 'sticky',
            top: ehMobile ? 56 : 0,
            left: 0,
            height: ehMobile ? 'calc(100vh - 56px)' : '100vh',
            zIndex: 150,
          }}
        >
          <div>
            <div style={{ padding: '24px 20px', borderBottom: `1px solid ${cores.card}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 8,
                    backgroundColor: cores.primario,
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gridTemplateRows: '1fr 1fr',
                    gap: 3,
                    padding: 7,
                    boxSizing: 'border-box',
                  }}
                >
                  <div style={{ backgroundColor: '#fff', borderRadius: 2 }} />
                  <div style={{ backgroundColor: '#fff', borderRadius: 2 }} />
                  <div style={{ backgroundColor: '#fff', borderRadius: 2 }} />
                  <div style={{ backgroundColor: '#fff', borderRadius: 2 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: cores.texto }}>
                    Sint Projetos
                  </div>
                  <div style={{ fontSize: 12, color: cores.textoSecundario }}>
                    Gestão de equipe
                  </div>
                </div>
              </div>
            </div>

            <nav style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 4 }}>
              {itensMenu.map((item) => (
                <NavLink
                  key={item.rota}
                  to={item.rota}
                  end={item.fim}
                  onClick={() => ehMobile && setMenuAberto(false)}
                  style={({ isActive }) => ({
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '10px 12px',
                    borderRadius: 8,
                    textDecoration: 'none',
                    fontSize: 14,
                    fontWeight: 600,
                    color: isActive ? cores.roxoEscuro : cores.textoSecundario,
                    backgroundColor: isActive ? cores.card : 'transparent',
                  })}
                >
                  <span>{item.icone}</span>
                  <span style={{ flex: 1 }}>{item.rotulo}</span>
                  {item.badge > 0 && (
                    <span
                      style={{
                        backgroundColor: cores.erro,
                        color: '#fff',
                        fontSize: 11,
                        fontWeight: 700,
                        borderRadius: 999,
                        minWidth: 18,
                        height: 18,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 5px',
                      }}
                    >
                      {item.badge}
                    </span>
                  )}
                </NavLink>
              ))}
            </nav>
          </div>

          <div style={{ padding: 16, borderTop: `1px solid ${cores.card}` }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <Avatar nome={usuario?.nome || usuario?.email || ''} size={36} />
              <div style={{ overflow: 'hidden' }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: cores.texto,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {usuario?.nome || 'Usuário'}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: cores.textoSecundario,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {usuario?.email}
                </div>
              </div>
            </div>
            <button
              onClick={aoSair}
              style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: 8,
                border: `1px solid ${cores.card}`,
                backgroundColor: 'transparent',
                color: cores.erro,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Sair
            </button>
          </div>
        </aside>
      )}

      <main
        style={{
          flex: 1,
          padding: 24,
          marginTop: ehMobile ? 56 : 0,
          minWidth: 0,
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
